import React, { useRef, useEffect, useMemo } from "react"
import { Container, Item, BoxItem } from "./style"
import { HashLink as Link } from 'react-router-hash-link';
import "./style.css"
import ScrollContainer from 'react-indiana-drag-scroll'
export default function ComponentName({ items = [], selectedIndex = 0, fromCardapio, fromTable, objTable }) {

  const scrollRef = useRef();

  let refs = {};

  for (let i = 0; i < items.length; i++) {
    refs[i] = React.createRef();
  }


  const scrollWithOffset = (el, offset) => {
    try {
      const elementPosition = el.offsetTop - offset;
      window.scroll({
        top: elementPosition,
        left: 0,
        behavior: "smooth"
      });
    } catch (error) {

    }

  }



  useEffect(() => {
    try {
      if (refs['0']) {
        scrollRef.current.scrollLeft = refs[selectedIndex].current.offsetLeft - 80
      }
    } catch (error) {

    }

  }, [selectedIndex])


  if (items.length === 0) return null;


  return (

    <Container className="containerMenuItens">
      <ScrollContainer innerRef={scrollRef} style={{ paddingBottom: 7 }}>
        {
          items.map((i, index) => {
            let base_url = ""
            if (fromTable) {
              base_url = `/estounamesa/${objTable.loja}/${objTable.mesa}#`
            } else {
              base_url = fromCardapio ? "/cardapio#" : "/LancaPedido#";
            }

            return <Link
              ref={refs[index]}
              scroll={el => scrollWithOffset(el, 20)}
              smooth to={`${base_url}${i.id}`}
              className="zeraLink"
              key={index}
            >
              <Item key={index} selected={index === selectedIndex}>{i.item.toString()}</Item>
            </Link>

          })
        }
      </ScrollContainer>
    </Container>

  )
}